const SCRATCH_ASSET_HOST = 'https://assets.scratch.mit.edu';
const SCRATCH_ASSET_CDN_HOST = 'https://cdn.assets.scratch.mit.edu';
const DOMI_SCRATCH_ASSET_CDN = 'https://cdn.domi.miaobi.cn/domi-scratch/assets';

export const getScratchAssetGetUrl = (
    assetId: string | number | undefined,
    dataFormat: string | undefined,
    assetHost?: string
): string => {
    const normalizedAssetHost = assetHost?.replace(/\/+$/, '');
    const usesOfficialAssetService = !normalizedAssetHost ||
        normalizedAssetHost === SCRATCH_ASSET_HOST ||
        normalizedAssetHost === SCRATCH_ASSET_CDN_HOST;
    if (usesOfficialAssetService) return `${DOMI_SCRATCH_ASSET_CDN}/${assetId}.${dataFormat}`;
    return `${normalizedAssetHost}/internalapi/asset/${assetId}.${dataFormat}/get`;
};
